<template>
  <div
    v-if="filtres.length"
    class="d-flex overflow-x"
  >
    <div
      v-for="(filtresParType, index) in filtresGroupByType"
      :key="index"
    >
      <v-chip
        class="pa-5 border-chip ma-1"
        color="white primary--text"
      >
        <div class="texte primary--text">
          {{ libelleFiltre(filtresParType) }}
        </div>
        <v-icon
          right
          @click="deleteFiltre(filtresParType)"
        >
          mdi-close
        </v-icon>
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltreContratChips',
  props: {
    /**
     * Exemple object : [{
     *   type: "filtresRegions"
     *   libelle: "REGION CALVADOS OUEST"
     * }, {
     *   type: "typeContrat"
     *   libelle: "Prix campagne"
     * }]
     */
    filtres: {
      type: Array,
      default: null
    }
  },
  computed: {
    filtresGroupByType () {
      const filtresGroupByType = Object.groupBy(this.filtres, ({ type }) => type)      
      return filtresGroupByType
    }

  },
  methods: {
    deleteFiltre (filtre) {
      this.$emit('delete', filtre)
    },
    libelleFiltre (filtresParType) {      
      let libellesParType = ''      
      filtresParType.forEach(filtreParType => {
        libellesParType = (libellesParType === '') ? filtreParType.libelle : (libellesParType + ', ' + filtreParType.libelle)
      })
      return libellesParType
    }
  }
}
</script>
<style lang="scss" scoped>
.border-chip {
  border-radius: 20px !important;
  border: 1px solid var(--gris-clair) !important;
}

.overflow-x {
  overflow-x: auto;
}
</style>
